import { ChainId } from '@padiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x128Cc68a909104443A024d72d4703E9ad6fF340E', // TODO
  [ChainId.TESTNET]: '0x1C2DdB78F1fBDE389D15acd275ce6b51EAFbBA14'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
